import { render, staticRenderFns } from "./ViewPolizaDataCard.vue?vue&type=template&id=46f7525c&scoped=true"
import script from "./ViewPolizaDataCard.vue?vue&type=script&lang=js"
export * from "./ViewPolizaDataCard.vue?vue&type=script&lang=js"
import style0 from "./ViewPolizaDataCard.vue?vue&type=style&index=0&id=46f7525c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f7525c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VExpansionPanelContent,VIcon,VRow})
